











































import Vue from 'vue'
import Await from '@/components/workflow/Await.vue'
import mixins from 'vue-typed-mixins'
import AuthorizationMixin from '@/routing/AuthorizationMixin'

export default mixins(AuthorizationMixin).extend({
  components: { Await },
  props: {
    after: {
      type: String,
    },
    timer: {
      type: String,
    },
    task: {
      type: String,
    },
  },
})
